// extracted by mini-css-extract-plugin
export var $animation_name = "Tabs-module--$animation_name--ae1ac";
export var tabs__list = "Tabs-module--tabs__list--bc6bb";
export var tabs__noSelectionMade = "Tabs-module--tabs__noSelectionMade--2cba9";
export var tabs__selectionMade = "Tabs-module--tabs__selectionMade--bafab";
export var tabs__tabpanel = "Tabs-module--tabs__tabpanel--8d037";